var gaEventsLegendView = {
    appPromo: {
        "brochure_view": {
            nav_icon: "view-menu-icon-landing",
            
            static_img: {
                apple: "view-last-page-apple",
                android: "view-last-page-android",
                landing: "view-last-page-landing"
            },
            popup: {
                apple: "pop-up-apple",
                android: "pop-up-android",
                landing: "pop-up-landing"
            }
        }
    }
};